@use '@/styles/tokens' as *;

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.times {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.label {
  font-size: 14px;
  color: var(--text-secondary);
}

.days {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.day {
  min-width: 48px;
  padding: 10px 8px;
  font-size: 13px;
  text-align: center;
  color: var(--text-primary);
  background: $color-brand-50;
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  cursor: pointer;
  transition:
    background 0.12s ease,
    color 0.12s ease,
    border-color 0.12s ease;

  &:hover {
    border-color: var(--border-default);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

.active {
  color: var(--text-inverse);
  background: $color-brand-700;
  border-color: $color-brand-700;

  &:hover {
    border-color: $color-brand-700;
  }
}

.repeat {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.repeatLabel {
  font-size: 15px;
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.hint {
  font-size: 13px;
  color: var(--text-muted);
}
